import { gql } from '@apollo/client';

import { mediaListItemFragment } from '../fragments';

export default gql`
  mutation UpdateMediaItem(
    $courseId: String!
    $subjectId: String!
    $mediaItemId: String!
    $input: UpdateMediaItemInput!
  ) {
    mediaItem(
      courseId: $courseId
      subjectId: $subjectId
      mediaItemId: $mediaItemId
      input: $input
    )
      @rest(
        type: "MediaItem"
        path: "courses/{args.courseId}/subjects/{args.subjectId}/videos/{args.mediaItemId}"
        method: "PUT"
      ) {
      ...MediaListItem
    }
  }
  ${mediaListItemFragment}
`;
